import React from 'react';

type Props = {
  message: string | undefined;
  /** id used by aria-describedby on the associated input */
  id?: string;
};

const InputError = ({ message, id }: Props) => {
  return (
    <>
      {message ? (
        <div
          id={id}
          role="alert"
          aria-live="polite"
          className="h-[16px] animate-slide-in-top-fast font-workSans text-[12px] text-red-800 transition-all"
        >
          {message}
        </div>
      ) : (
        <div
          id={id}
          aria-hidden="true"
          className="h-[16px] animate-fade-in-down font-workSans text-[12px] text-red-800 transition-all"
        />
      )}
    </>
  );
};

export default InputError;
